module.exports = __webpack_public_path__ + "img/AGR-B-1-III.21216643.png";